import { useQuery } from '@tanstack/react-query';
import { useReviewPreviewPageStatus, useReviewPreviewParams } from 'screens/performanceReview/hooks/reviewPreviewHooks';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getReviewHelpDocuments, getSummaryStats } from 'services/performanceReview';

const checkRequiredQuestionsAnswered = ({ formNames }) => {
  const unansweredRequiredQuestionsCount = formNames.reduce(
    (acc, { unansweredRequiredQuestions }) => acc + unansweredRequiredQuestions ?? 0,
    0
  );
  return !unansweredRequiredQuestionsCount;
};

const getData = ({
  employeeId,
  reviewId,
  providerId,
  useOldEndpoint = false,
  isPreview,
  providerType,
  previewSubmissionStatus,
}) =>
  getSummaryStats({
    employeeId,
    reviewId,
    providerId,
    useOldEndpoint,
    isPreview,
    providerType,
    previewSubmissionStatus,
  }).then((res) => {
    const isAllRequiredQuestionsAnswered = checkRequiredQuestionsAnswered({
      formNames: res.formNames,
    });
    return { ...res, isAllRequiredQuestionsAnswered };
  });

const getFAQData = ({ reviewId }) => getReviewHelpDocuments({ reviewId }).then((res) => res);

export const useReviewFormSidebarData = ({ employeeId, reviewId, providerId }) => {
  const { isPreview, providerType } = useReviewPreviewParams();
  const previewSubmissionStatus = useReviewPreviewPageStatus();
  return useQuery(
    [REACT_QUERY_KEYS.ReviewFormSidebar, employeeId, reviewId, providerId],
    () =>
      getData({
        employeeId,
        reviewId,
        providerId,
        providerType,
        isPreview,
        previewSubmissionStatus,
      }),
    { enabled: !!employeeId, retry: false }
  );
};

export const useReviewFormSidebarDataOld = ({ employeeId, reviewId, providerId }) => {
  const { isPreview, providerType } = useReviewPreviewParams();
  const previewSubmissionStatus = useReviewPreviewPageStatus();
  return useQuery(
    [REACT_QUERY_KEYS.ReviewFormSidebar, employeeId, reviewId, providerId],
    () =>
      getData({
        employeeId,
        reviewId,
        providerId,
        providerType,
        isPreview,
        previewSubmissionStatus,
        useOldEndpoint: true,
      }),
    { enabled: !!employeeId, retry: false }
  );
};

export const useReviewFAQData = ({ reviewId }) =>
  useQuery(
    [REACT_QUERY_KEYS.ReviewFAQData, reviewId],
    () =>
      getFAQData({
        reviewId,
      }),
    { enabled: !!reviewId }
  );
